<template>
  <div ref="sideBox" class="live-sidebox" v-if="showChat || showQA">
    <div class="live-sidebox-header">
      <div class="live-sidebar-item"
        :class="{ 'active': item === selectedSideInteraction, 'solo': boxInteractivities.length === 1 }"
        v-for="item in boxInteractivities" :key="item" @click="openSideboxTab(item)">
        <ion-icon class="chat-icon" name="chatbubbles-outline" v-if="item === 'chat'"></ion-icon>
        <ion-icon class="qa-icon" name="chatbubble-outline" v-if="item === 'qa'"></ion-icon>
        <span>
        {{ activityData.property.interactivities[item].config.barText ?
            activityData.property.interactivities[item].config.barText :
            activityData.property.interactivities[item].config.displayName
        }}
        </span>

      </div>
    </div>
    <Chatbox  ref="chatBox"
      :activityData="activityData" 
      :channel="channel"
      v-if="selectedSideInteraction === 'chat'"
    />
    <QnABox ref="qnaBox"
      :activityData="activityData"
      :config="activityData.property.interactivities.qa.config"
      :disableAutoScroll="activityData.property.interactivities.qa.config.disableAutoScroll"
      :placeholder="activityData.property.interactivities.qa.config.placeholder"
      v-if="selectedSideInteraction === 'qa'" 
    />
  </div>
</template>

<script>
import Chatbox from '@/components/chat_qa_box/Chatbox.vue';
import QnABox from '@/components/chat_qa_box/QnABox.vue';

export default {
  name: 'sidebox',

  components: {
    Chatbox,
    QnABox
  },

  props: {
    activityData: {
      type: Object,
      required: false,
      default: () => {
        return {
          property: {
            enableChatreply: true,
            enableChatGiphy: false,
            enableChatUserAvatar: true,
            interactivities: {
              chat: {
                config: {
                  displayName: 'Chat',
                  iconClass: 'fas fa-comments',
                }
              }
            }
          },
          interactivities: {
            chat: true,
            qa: false
          }
        }
      }
    },
    channel: {
      type: String,
      default: ''
    },
    showQA: {
      type: Boolean,
      required: false,
      default: false
    },
    refHeight: {
      type: Number,
      required: false,
      default: 0
    },
    isSupport: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      showChat: false,
      selectedSideInteraction: 'chat',
      sideboxHeight: '',
    };
  },

  computed: {
    boxInteractivities() {
      let parsed = [];
      if (this.activityData.interactivities.chat) {
        parsed.push('chat');
      }
      if (this.activityData.interactivities.qa && this.showQA) {
        parsed.push('qa');
        if (!this.activityData.interactivities.chat) this.openSideboxTab('qa');
      }
      return parsed;
    },
  },

  methods: {
    openSideboxTab(item) {
      this.selectedSideInteraction = item;
      this.$emit('openSideboxTab', item);
    },
    resized(newRect) {
      if (newRect) {
        if (newRect.height < 300) newRect.height = 300;
        this.$refs.sideBox.style.height = newRect.height + 'px';
        this.$refs.sideBox.style.width = newRect.width + 'px';
        return
      }
      if (!this.isSupport && this.$refs.sideBox && document.getElementById('liveVideoViewPort')) {
        this.$refs.sideBox.style.height = document.getElementById('liveVideoViewPort').clientHeight + 'px';
        if (window.innerWidth < 706) {
          this.$refs.sideBox.style.height = window.innerHeight - document.getElementById('liveVideoViewPort').clientHeight + 60 + 'px';
          if (document.getElementById('liveVideoViewPort').clientHeight < 300) {
            this.$refs.sideBox.style.height = '480px';
          }
        }
      }
      if (this.refHeight && this.$refs.sideBox) {
        this.$refs.sideBox.style.height = this.refHeight + 'px';
        return
      }
    },
  },

  mounted() {
    this.showChat = this.activityData.interactivities.chat;
    setTimeout(() => {
      this.resized();
    }, 1000);
  },
}
</script>

<style lang="scss">
.live-sidebox {
  position: relative;
  width: 28%;
  min-width: 300px;
  height: 400px;
  background: red;
  background: var(--chat-mainColor) !important;
  border: 1px solid var(--chat-outlineColor) !important;
  border-radius: var(--chat-borderRadius);
  pointer-events: auto;

  display: flex;
  flex-direction: column;
  align-content: stretch;

  @include media("<=tablet") {
    // margin: 0 16px;
    padding: 0;
    height: 60vh;
    width: auto;
  }

  @include media("<=phone") {
    // margin: 0 10px;
    // height: 800px;
  }

  &:hover .live-sidebox-header {
    opacity: 1;
  }

  .live-sidebox-header {
    cursor: pointer;
    user-select: none;
    position: absolute;
    inset: 0 auto auto auto;
    width: 100%;
    height: 48px;
    z-index: 1;
    border-radius: var(--chat-borderRadius) var(--chat-borderRadius) 0 0;
    overflow: hidden;

    display: flex;
    align-items: center;
    justify-content: stretch;

    opacity: 1;
    transition: opacity 0.3s ease-in-out;

    &:hover {
      opacity: 1;
    }

    .live-sidebar-item {
      position: relative;
      margin: auto auto auto auto;
      width: 100%;
      height: 100%;
      color: var(--chat-headerColor);
      background: var(--chat-mainColor);
      font-size: 1rem;
      opacity: 0.7;

      display: flex;
      align-items: center;
      justify-content: center;

      transition: opacity 0.3s ease-in;

      &:hover {
        opacity: 1;
      }
    }

    .chat-icon,
    .qa-icon {
      position: relative;
      color: var(--chat-headerColor);
      margin-right: 8px;
      font-size: 1.5rem;
    }

    .qa-icon {
      font-size: 1.3rem;
    }

    .active {
      background: transparent;
      opacity: 1;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      border-bottom-color: var(--chat-headerColor);
      transition: opacity 0.3s ease-in;
    }

    .solo {
      cursor: auto;
      margin-left: 12px;
      font-size: 1.3rem;
      border-bottom-width: 0;
      justify-content: flex-start;
    }
  }
}
</style>